// sample.band color system
// White canvas, red/gray chrome — color comes from the samples and chops.

// Legacy track colors (still used by the old dark-theme components)
export const TRACK_COLORS = [
  { name: 'blue', hex: '#92A8D1', rgb: '146, 168, 209' },
  { name: 'cyan', hex: '#70C8C8', rgb: '112, 200, 200' },
  { name: 'yellow', hex: '#C8B830', rgb: '200, 184, 48' },
  { name: 'orange', hex: '#D89050', rgb: '216, 144, 80' },
  { name: 'pink', hex: '#D88888', rgb: '216, 136, 136' },
  { name: 'purple', hex: '#B080C8', rgb: '176, 128, 200' }
];

export const getTrackColor = (index) => {
  return TRACK_COLORS[index % TRACK_COLORS.length];
};

export const getTrackColorWithAlpha = (index, alpha = 0.85) => {
  const color = getTrackColor(index);
  return `rgba(${color.rgb}, ${alpha})`;
};

// Chop keys in trigger order: every letter, keyboard rows top to bottom.
// Q = first chop = red, W = second = orange, and so on; the 16-hue palette
// cycles for the later keys.
export const CHOP_KEYS = [
  'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
  'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
  'Z', 'X', 'C', 'V', 'B', 'N', 'M'
];

// One hue per key, warm to cool. Saturated enough to read on white at full
// strength, still distinct when dimmed to ~35% for the resting state.
export const CHOP_COLORS = [
  { name: 'red', hex: '#E03131', rgb: '224, 49, 49' },       // Q
  { name: 'orange', hex: '#F76707', rgb: '247, 103, 7' },    // W
  { name: 'amber', hex: '#F59F00', rgb: '245, 159, 0' },     // E
  { name: 'ochre', hex: '#C0A00C', rgb: '192, 160, 12' },    // R
  { name: 'lime', hex: '#66A80F', rgb: '102, 168, 15' },     // T
  { name: 'green', hex: '#2B8A3E', rgb: '43, 138, 62' },     // Y
  { name: 'teal', hex: '#099268', rgb: '9, 146, 104' },      // U
  { name: 'cyan', hex: '#0C8599', rgb: '12, 133, 153' },     // I
  { name: 'blue', hex: '#1971C2', rgb: '25, 113, 194' },     // A
  { name: 'indigo', hex: '#3B5BDB', rgb: '59, 91, 219' },    // S
  { name: 'violet', hex: '#6741D9', rgb: '103, 65, 217' },   // D
  { name: 'purple', hex: '#9C36B5', rgb: '156, 54, 181' },   // F
  { name: 'magenta', hex: '#C2255C', rgb: '194, 37, 92' },   // G
  { name: 'crimson', hex: '#A61E4D', rgb: '166, 30, 77' },   // H
  { name: 'brown', hex: '#846358', rgb: '132, 99, 88' },     // J
  { name: 'slate', hex: '#495057', rgb: '73, 80, 87' }       // K
];

export const getChopColor = (key) => {
  const index = CHOP_KEYS.indexOf((key || 'Q').toUpperCase());
  const safeIndex = index >= 0 ? index : 0;
  return { index: safeIndex, ...CHOP_COLORS[safeIndex % CHOP_COLORS.length] };
};

export const getChopColorByChop = (chop) => {
  if (!chop || !chop.key) return getChopColor('Q');
  return getChopColor(chop.key);
};
